import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

Date.prototype.Format = function (fmt) {
    let o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'H+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'S+': this.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(String(o[k]).length)));
        }
    }
    return fmt;
};

Date.prototype.FormatAll = function () {
    return this.Format('yyyy-MM-dd HH:mm:ss');
};

Date.prototype.GetTimeS = function () {
    return Math.floor(this.getTime() / 1000);
};

Date.ZeroTime = function (time) {
    if (!time) time = Date.now();

    let d = new Date(time);
    return time - d.getHours() * 3600000 - d.getMinutes() * 60000 - d.getSeconds() * 1000 - d.getMilliseconds();
};

Date.ZeroTimeS = function (time) {
    return Date.ZeroTime(time) / 1000;
};

Array.prototype.PushValueListString = function (str, char) {
    let list = str.split(char);
    for (let value of list) {
        this.push({value});
    }
    return this;
};

Array.prototype.ToValueListString = function (char) {
    let str = '';
    for (let obj of this) {
        if (str) str += char + obj.value;
        else str += obj.value;
    }
    return str;
};

const app = createApp(App)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}